import React from 'react';
import { observer } from 'src/utils/mobx-react';
import { I18n } from 'src/domains/layouts/webview/components/language/I18n';
import {
    KycWarningContainer,
    KycWarningIconWrapper,
} from 'src/domains/players/webview/components/WithdrawAndDeposit/depositProcedure/topUpProcedureParts/kycWarning/KycWarning.style';
import { useCommon } from 'src/domains/common/Common';
import { ConfigComponents } from 'src/domains/layouts/config/features/config';
import { UsersState } from 'src/domains/players/state/UsersState';

interface PropsType {
    isSignup: boolean;
}

export const KycWarning = observer('KycWarning', ({ isSignup }: PropsType) => {
    const common = useCommon();
    const configComponents = ConfigComponents.get(common);
    const usersState = UsersState.get(common);
    const kycStatus = usersState.basicData.valueReady?.kycStatus ?? '';

    const kycWarningEnabled = kycStatus === 'requested';
    const email = configComponents.config.emailKycWarning;

    if (configComponents.config.showKycDepositWaring === false) {
        return null;
    }

    if (kycWarningEnabled) {
        return (
            <KycWarningContainer
                isSignup={isSignup}
                data-test='kyc-warning'
            >
                <KycWarningIconWrapper isSignup={isSignup} />
                <div data-test='kyc-warning-text'>
                    <I18n
                        langKey='account.kyc-warning.first.line2'
                        defaultText='As part of our Know Your Customer verification, we will require a copy of your driving licence or passport and a copy of utility bill, bank statement or payslip showing your current address not more than 3 months old.'
                    />
                    <br />
                    <I18n
                        langKey='account.kyc-warning.first.line3'
                        defaultText='You may not be able to make a withdrawal or your account may be suspended until your account is verified.'
                    />
                    <br />
                    <I18n
                        langKey='account.kyc-warning.first.line4'
                        defaultText='Please send all documentation to {email}'
                        params={{ email }}
                    />
                </div>
            </KycWarningContainer>
        );
    }

    return null;
});
